import {CustomerDto} from '../../../../../../PRMGApiClient';
import {action, makeObservable, observable} from 'mobx';
import {Api} from '../../../../../../PRMGApiClient/ApiClient';
import {showCommunicationError} from '../../../helpers/alerts';
import {TablePaginationConfig} from 'antd';
import {FilterValue} from 'antd/es/table/interface';

export class CustomersState {
  @observable
  items: Array<CustomerDto> = [];

  @observable
  pageNumber: number = 1;

  @observable
  pageSize: number = 10;

  @observable
  total: number = 0;

  @observable
  isLoading: boolean = false;

  filterUserName: string | undefined;

  constructor() {
    makeObservable(this);
  }

  @action
  loadCustomers() {
    this.isLoading = true;
    Api.Customer.apiCustomerFindByGet({
      pageNumber: this.pageNumber,
    })
      .then((res) => {
        this.setItems(res.content?.items);
        this.setTotal(res.content?.total);
      })
      .catch(showCommunicationError)
      .finally(() => {
        this.isLoading = false;
      });
  }

  @action
  setItems(items: Array<CustomerDto> | null | undefined) {
    this.items = items || [];
  }

  @action
  setTotal(number: number | undefined) {
    this.total = number ?? 0;
  }

  @action
  filterCustomerName() {
    return true;
  }

  @action
  setCustomersFilters(customerId?: number) {
    // if (vehicleId) {
    //   Api.Car.getCarById({id: vehicleId})
    //     .then((res) => {
    //       this.filterCarName =
    //         res.content?.carModelName + ' ' + res.content?.carMakeName + ' ' + res.content?.manufactureYear;
    //       this.filtersCarId = vehicleId;
    //       this.loadServices();
    //     })
    //     .catch(showCommunicationError);
    // } else {
    //   this.filterCarName = undefined;
    //   this.filtersCarId = undefined;
    //   this.loadServices();
    // }
    console.log('set customers filters', customerId);
  }

  @action
  setPagination(pagination: TablePaginationConfig) {
    this.pageNumber = pagination.current || 1;
    this.pageSize = pagination.pageSize || 10;
    this.loadCustomers();
  }

  setFilters(filters: Record<string, FilterValue | null>) {
    console.log(filters);
    this.loadCustomers();
  }
}
